export class EnvUtil {
  public static isDev() {
    return process.env.VUE_APP_ENV === 'dev'
  }

  public static isProd() {
    return process.env.VUE_APP_ENV === 'prod'
  }

  public static isStaging() {
    return process.env.VUE_APP_ENV === 'staging'
  }

  public static isAPP(name: string) {
    return process.env.VUE_APP_NAME && process.env.VUE_APP_NAME.toLowerCase().includes(name)
  }

  public static isISC() {
    return this.isAPP('isc')
  }

  public static isSaas() {
    return this.isAPP('shs')
  }

  public static isApph5() {
    return this.isAPP('apph5')
  }

  public static isCampus() {
    return this.isAPP('campus')
  }

  public static isAgency() {
    return this.isAPP('agency')
  }

  public static isOperation() {
    return this.isAPP('operation')
  }

  public static isJumpStar() {
    return this.isAPP('jumpstar')
  }

  public static appName() {
    return process.env.VUE_APP_NAME || ''
  }

  public static appNameZHCN() {
    return process.env.VUE_APP_NAME_ZHCN || ''
  }

  public static appNameDesc() {
    return process.env.VUE_APP_NAME_DESC || ''
  }

  public static buildLogFileName() {
    return `kd${this.appName()}`
  }

  /**
   * 构建校园端完整 URL
   * @param path - 路径参数，可选，支持带/开头或不带/开头，或不传
   * @returns 完整的校园端 URL，格式：{host}/campus/#/{path}
   * @example
   * buildCampusUrl() // 'https://www-test.tiantiantiaosheng.com/campus/#/'
   * buildCampusUrl('class-match-system/scan') // '.../campus/#/class-match-system/scan'
   * buildCampusUrl('/auth-form') // '.../campus/#/auth-form'
   */
  public static buildCampusUrl(path?: string): string {
    const host = this.isProd() ? 'https://www.tiantiantiaosheng.com' : 'https://www-test.tiantiantiaosheng.com'
    const baseUrl = `${host}/campus/#`

    if (!path) {
      return `${baseUrl}/`
    }

    // 确保 path 以 / 开头
    const normalizedPath = path.startsWith('/') ? path : `/${path}`
    return `${baseUrl}${normalizedPath}`
  }
}
